import { render, staticRenderFns } from "./statistics copy.vue?vue&type=template&id=cdc4b1e8&"
import script from "./statistics copy.vue?vue&type=script&lang=js&"
export * from "./statistics copy.vue?vue&type=script&lang=js&"
import style0 from "./statistics copy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports